export default __webpack_public_path__ + "static/media/icon-flag-belgium.5574109a.svg";